// Palette tuned for the dark dashboard background (~#07091D). Every entry clears
// WCAG 3:1 contrast against that background while keeping adjacent channels
// perceptually distinct (min CIEDE2000 ~12.5 across the first 16 channels) so a
// single ROI chart can plot 10+ series without look-alikes.
//
// Colors are kept vivid (not pastel) so the chart lines read on the dark canvas.
// On the white tooltip/legend background the small dots get a thin dark outline
// (see GlobalTooltip / HighlightLegend) rather than being lightened, which would
// otherwise wash these colors out on white.
export const colors = [
    '#2c55f6', // was #2b67ff — deepened blue
    '#73efea',
    '#f93c5e',
    '#ffce2d',
    '#901cfd', // was #7031e5 — vivid purple
    '#73efac',
    '#ed9fb2',
    '#129f53',
    '#ff652d',
    '#25b4c1', // was #050075 — near-black navy re-hued to teal (was invisible)
    '#f9f835',
    '#cf17b5', // was #a50fa9 — vivid magenta
    '#d4fbd3',
    '#73b6ef',
    '#ffffbc',
    '#ab8a77',
    '#f2daff',
    '#a760f6', // was #856597 — vivid purple
    '#307ffd', // was #4258a6 — vivid blue
    '#d51b10', // was #7e2924 — dark red lifted to vivid red
    '#dce6ff',
    '#18cc57', // was #105b2e — dark green lifted
    '#8c88d7',
    '#d4c95c',
    '#e76cef',
    '#c42162', // was #b00029 — maroon lifted to vivid rose
    '#e18e19', // was #020b39 — near-black navy re-hued to amber (was invisible)
    '#90a65d',
];

export function getColor(index: number) {
    return colors[index % colors.length]!;
}
